/**
 * 레이아웃 컴포넌트 상수
 */
import {
    Article,
    Assignment,
    Code,
    EditNote,
    Group,
    Groups,
    HelpOutline,
    HowToReg,
    MenuBook,
    School,
    Security,
} from '@mui/icons-material';

export const LAYOUT_CONSTANTS = {
    SIDEBAR_WIDTH: 250,
    APP_BAR_HEIGHT: 50,
    TOOLBAR_HEIGHT: 40,
    AUTH_RESET_DELAY: 500,
};

/**
 * 메뉴 섹션 타입
 * @typedef {Object} MenuSection
 * @property {string} key - 섹션 키
 * @property {string} title - 섹션 제목
 * @property icon - MUI SvgIcon 컴포넌트(컴포넌트 참조)
 * @property {MenuItem[]} items - 하위 메뉴 아이템 배열
 */

/**
 * 메뉴 섹션 데이터
 * 각 섹션의 제목, 아이콘, 하위 메뉴 아이템을 정의합니다.
 *
 * @type {MenuSection[]}
 */
export const MENU_SECTIONS = [
    {
        key: 'users',
        title: '회원 및 그룹 관리',
        icon: Group,
        items: [
            {
                label: '교육생 관리',
                icon: HowToReg,
                path: '/students',
            },
            {
                label: 'FT/OPER/ADM 관리',
                icon: Group,
                path: '/managers',
            },
            {
                label: '그룹 관리',
                icon: Groups,
                path: '/groups',
            },
        ],
    },
    {
        key: 'education',
        title: '교육 운영',
        icon: School,
        items: [
            {
                label: '강의 관리',
                icon: MenuBook,
                path: '/education/courses',
            },
            {
                label: '과제 관리',
                icon: Assignment,
                path: '/education/assignments',
            },
            {
                label: '진단 및 대응훈련 관리',
                icon: Security,
                path: '/education/trainings',
            },
            {
                label: '프로젝트 개발훈련 관리',
                icon: Code,
                path: '/education/projects',
            },
        ],
    },
    {
        key: 'community',
        title: '게시판 관리',
        icon: Article,
        items: [
            {
                label: '자료실 관리',
                icon: EditNote,
                path: '/community/library',
            },
            {
                label: 'FAQ 관리',
                icon: HelpOutline,
                path: '/community/faq',
            },
        ],
    },
];
